import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ExternalLink } from "lucide-react";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import { purchaseDetails } from "@/lib/purchases";

export const ExternalCheckout = ({ items }) => {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.get("/shop/products").then((r) => {
      if (!cancelled) setProducts(r.data);
    }).catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16 min-h-[60vh]" data-testid="external-checkout">
      <Seo title="Vos achats" description="Retrouvez les liens d'achat de vos produits." path="/checkout" noindex />
      <Link to="/boutique" data-testid="external-checkout-back" className="inline-flex items-center gap-2 text-gold font-semibold mb-8 hover:underline">
        <ArrowLeft size={16} /> Retour à la boutique
      </Link>
      <h1 className="font-heading text-3xl text-brown-black mb-8">Vos achats</h1>
      {error ? <p role="alert" data-testid="external-checkout-error">Les liens d'achat sont momentanément indisponibles.</p>
        : !products ? <p data-testid="external-checkout-loading">Chargement…</p>
        : items.length === 0 ? <p data-testid="external-checkout-empty">Votre panier est vide.</p>
        : <ul className="divide-y divide-gold/20">
          {items.map((item) => {
            const product = products.find((p) => p.id === item.id);
            const purchase = product ? purchaseDetails(product) : null;
            return (
              <li key={item.key} className="flex flex-wrap items-center justify-between gap-4 py-6" data-testid={`external-checkout-item-${item.key}`}>
                <span className="font-heading text-xl text-brown-black break-words min-w-0" data-testid={`external-checkout-name-${item.key}`}>{product?.name || item.name}</span>
                {purchase?.external ? <a href={purchase.url} target="_blank" rel="noopener noreferrer" data-testid={`external-checkout-buy-${item.key}`} className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-gold text-white font-semibold hover:bg-gold-light transition-colors">
                  <ExternalLink size={16} /> {purchase.label}
                </a> : <span className="text-sm text-brown-black/60" data-testid={`external-checkout-unavailable-${item.key}`}>Produit indisponible</span>}
              </li>
            );
          })}
        </ul>}
    </div>
  );
};